<template>
    <div class="client-row">
        <label for="currentTimePeriod" class="col-3">Current Wave Period</label>
        <div class="col-9 d-flex pl-0">
          <div class="col-3 m-0 p-0 d-flex">
            <select id="currentTimePeriod" name="currentTimePeriod" v-model="currentTimePeriodId" class="form-control w-100" :disabled="disabled" @change="saveCurrentWave">
                <option value="0">Select</option>
                <option v-for="(current_time_period_option, idxCurrentClientTimePeriodOptions) in client_time_period_options" 
                        v-bind:value="current_time_period_option.clientTimePeriodId" v-bind:key="idxCurrentClientTimePeriodOptions">
                    {{ current_time_period_option.displayName }}
                </option>
            </select>
          </div>
          <div class="col-6 ml-1">
              <button type="button" class="btn btn-primary" :disabled="this.inputClientCode == ''" @click="openApplyToClientHierarchy">Apply to Client Hierarchy</button>
          </div>
        </div>
        <modal
            :modal-id="'Apply to Client Hierarchy For Current Time Period'"
            :modal-title="'Apply to Client Hierarchy'"
            :modal-content="'Are you sure you want apply the current time period to all organizations in this hierarchy ?'"
            :include-confirmation="true"
            @confirm="applyCurrentTimePeriodToHierarchy"
          />
    </div>  

</template>
<script>
import ClientTimePeriodService from "../services/client.time.period.service";
import AdminService  from "../services/admin.service";
import ViewMixins from "../mixins/ViewMixins.vue";
export default {
  name: "CurrentTimePeriod",
  mixins: [ViewMixins],
  components: {},
  data() {
    return {
        client_time_period_options: [],
        currentTimePeriodId: 0,
        applyToHierarchy: 'N',
    };
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    inputClientCode: {
        type: String,
        default: ""
    },      
    inputClientTimePeriodOptions: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    
  },
  mounted() {
    
  },
  created() {},
  methods: {
    openApplyToClientHierarchy: function(){
        this.applyToHierarchy = 'Y';
        this.$modal.show("Apply to Client Hierarchy For Current Time Period");
    },
    applyCurrentTimePeriodToHierarchy: function(){
        this.applyToHierarchy = 'Y';
        this.saveCurrentWave(true);
    },
    saveCurrentWave(withHierarchy = false) {
        if (withHierarchy){
            this.$root.processServerRequest("Saving current time period for hierarchy");        
        } else {
           this.$root.processServerRequest("Saving current time period");        
        }
        ClientTimePeriodService.saveCurrentWave(this.inputClientCode, this.currentTimePeriodId, this.applyToHierarchy, this.saveCurrentWaveCallback, this)
    },
    saveCurrentWaveCallback(response) {
        this.$root.processServerResponse();
      if (response.data.statusCode == 200) {
        AdminService.displaySuccessMessage({ text: response.data.message });
      } else {
        AdminService.displayErrorMessage({ text: response.data.message });
      }
      this.applyToHierarchy = 'N';
    }
  },
  watch: {
    inputClientTimePeriodOptions: function(){
        this.client_time_period_options = this.inputClientTimePeriodOptions;
        this.currentTimePeriodId = this.client_time_period_options.find(x => x.isCurrent == 'Y') ? 
                this.client_time_period_options.find(x => x.isCurrent == 'Y').clientTimePeriodId : 0; 
    }
  },
};
</script>
